
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.32 8.936l-3.523 3.075 1.055 4.578a1.25 1.25 0 01-1.862 1.355l-3.993-2.422-3.984 2.422a1.25 1.25 0 01-1.863-1.355l1.054-4.573-3.524-3.08a1.25 1.25 0 01.711-2.192l4.646-.403L8.85 2.016a1.246 1.246 0 012.3 0l1.819 4.325 4.644.403a1.25 1.25 0 01.711 2.192h-.004z","fill":"#D3D7E1"}}),_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"mask0_45198_59901","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"10","height":"19"}},[_c('path',{attrs:{"fill":"#D9D9D9","d":"M0 0h10v19H0z"}})])])
          )
        }
      }
    